import { Dispatch } from '@/context/types';
import { deepKeys } from '@/utils';

interface Errors {
  [key: string]: string;
}

export function ckeckIfHasErrors(errors: Errors) {
  if (!errors) return [];
  return Object.keys(errors).filter((key: keyof Errors) => typeof errors[key] === 'string');
}

const getElement = (name: string) => document.querySelector<HTMLInputElement>(`[name='${name}']`);

export function useFieldFocus() {
  return (errors: Errors) => {
    const errorKeys = deepKeys(errors);
    const [firstField] = errorKeys.filter((key) => !getElement(key)?.disabled);
    const fieldElement = getElement(firstField);

    if (!fieldElement) return;
    fieldElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };
}

export function useErrorFieldHandler(dispatch: React.Dispatch<Dispatch>) {
  return (errors: Errors) => {
    const errorKeys = deepKeys(errors);

    if (!errorKeys.length) {
      dispatch({ action: 'risk_set_is_valid', payload: true });
    }
  };
}
